import React from "react";
import "./listing-approval-section.scss";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { updateListing } from "../../../../requests/listingsApi";
import "react-photo-view/dist/react-photo-view.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const ListingApprovalSection = ({ data }) => {
  const userFormik = useFormik({
    initialValues: {
      reason_of_rejection: "",
    },
    validationSchema: Yup.object({
      reason_of_rejection: Yup.string().required("Enter Reason of Rejection"),
    }),
    onSubmit: async(values) => {
      const res = await updateListing(data._id, { status: "rejected", reasonOfRejection: values.reason_of_rejection, merchantId: data.merchant, sendEmail: true})
      if(res.status) {
        toast.success("Listing has been rejected")
      } else {
        toast.error(res.message)
      }
    },
  });

  const pictures = data.pictures;

  const videoThumbnail = "/images/hotels/hotel-2.svg";
  const videoUrl = data.video;

  const handleListingUpdate = async(listingData) => {
    const res = await updateListing(listingData?._id, { status: 'approved'})
    if(res.status) {
      toast.success("Listing has been approved")
    } else {
      toast.error(res.message)
    }
  }
  return (
    <>
      <section className="listing-approval-page">
        <div className="listing-apprval-wrap">
          <h2>Listing Approval</h2>
          <div className="row">
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Product Name</span>
                <p>{data.productName}</p>
              </div>
            </div>
            <div className="col-xl-3 col-md-6 p-2">
              <div className="kyc-box">
                <span>Category</span>
                <p>{data.category}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="listing-apprval-wrap">
          <h2>Media</h2>
          <div className="media-content-wrap">
            <div className="row">
              <div className="col-lg-6">
                <h5>Pictures</h5>
                <PhotoProvider>
                  <div className="main-picture">
                    <PhotoView src={pictures[0]}>
                      <img
                        src={pictures[0]}
                        alt="Main Pic"
                        className="img-fluid"
                      />
                    </PhotoView>
                  </div>
                  <div className="small-pictures">
                    {pictures.slice(1).map((pic, index) => (
                      <PhotoView key={index} src={pic}>
                        <img
                          src={pic}
                          alt={`pic-${index}`}
                          className="img-thumbnail small-thumb"
                        />
                      </PhotoView>
                    ))}
                  </div>
                </PhotoProvider>
              </div>
              <div className="col-lg-6 mt-lg-0 mt-4">
                <h5>Video</h5>
                <PhotoProvider>
                  <div className="main-picture">
                    <PhotoView src={videoUrl}>
                      <img
                        src={videoThumbnail}
                        alt="Video"
                        className="img-fluid"
                      />
                    </PhotoView>
                  </div>
                </PhotoProvider>
              </div>
            </div>
          </div>
        </div>
        <div className="listing-apprval-wrap">
          <h2>Product Detail</h2>
          <div className="product-detail-content">
            <div dangerouslySetInnerHTML={{ __html: data.description }}></div>
          </div>
        </div>
        <div className="listing-apprval-wrap">
          <h2>Sales Information</h2>
          <div className="row">
            <div className="col-xl-4 col-md-6 p-2">
              <div className="kyc-box">
                <span>Availability Details</span>
                <p>
                  {data.salesInfo.availabilityDate.type === "custom"
                    ? `From: ${data.salesInfo.availabilityDate.dates[0].from} To: ${data.salesInfo.availabilityDate.dates[0].to}`
                    : `Everyday`}
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 p-2">
              <div className="kyc-box">
                <span>Availability Timing</span>
                <p>
                  {data.salesInfo.availabilityTiming.type === "custom"
                    ? `From: ${data.salesInfo.availabilityTiming.timings[0].from} To: ${data.salesInfo.availabilityTiming.timings[0].to}`
                    : `Fixed - 0800 - 1800`}
                </p>
              </div>
            </div>
            <div className="col-xl-4 col-md-6 p-2">
              <div className="kyc-box">
                <span>Attraction Duration</span>
                {/* <p>No Time Limit</p> */}
                <p>
                  {data.salesInfo.attractionDuration.type === "custom"
                    ? `From: ${data.salesInfo.attractionDuration.timings[0].from} To: ${data.salesInfo.attractionDuration.timings[0].to}`
                    : `No Time Limit`}
                </p>
              </div>
            </div>
            <div className="col-lg-6 p-2">
              <div className="kyc-box">
                <span>Pricing</span>
                <div className="table-responsive">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          Adult <span>(Aged 12+)</span>
                        </td>
                        <td>
                          {" "}
                          <span>
                            {data.salesInfo.pricing?.adult.value || 0}
                          </span>
                        </td>
                        <td>{data.salesInfo.pricing?.adult.currency || 0}</td>
                      </tr>
                      <tr>
                        <td>
                          Children <span>(3-11)</span>
                        </td>
                        <td>
                          {" "}
                          <span>
                            {data.salesInfo.pricing?.children3to11.value || 0}
                          </span>
                        </td>
                        <td>
                          {data.salesInfo.pricing?.children3to11.currency || 0}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Children <span>(1-2)</span>
                        </td>
                        <td>
                          {" "}
                          <span>
                            {data.salesInfo.pricing?.children1to2.value || 0}
                          </span>
                        </td>
                        <td>
                          {data.salesInfo.pricing?.children1to2.currency || 0}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          Toddler <span>(0-1)</span>
                        </td>
                        <td>
                          {" "}
                          <span>Free</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="listing-apprval-wrap action-btns">
          <button
            id="reject-btn"
            data-bs-toggle="modal"
            data-bs-target="#rejectListingModal"
          >
            Reject
          </button>
          <button id="approve-btn" onClick={() => handleListingUpdate(data)}>Approve</button>
        </div>
      </section>

      <div
        className="modal fade"
        id="rejectListingModal"
        tabIndex="-1"
        aria-labelledby="rejectListingModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content reject-modal">
            <div className="modal-body">
              <div className="modal-header">
                <h5 className="modal-title">Reject Listing</h5>
                <img
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  src="/images/icons/close-circle.svg"
                  alt="close-circle"
                />
              </div>
              <form className="reject-info" onSubmit={userFormik.handleSubmit}>
                <p className="modal-note">
                  Are you sure you want to reject this listing?
                </p>
                <div className="user-inputs">
                  <div className="floating-label">
                    <textarea
                      name="reason_of_rejection"
                      value={userFormik.values.reason_of_rejection}
                      onChange={userFormik.handleChange}
                      onBlur={userFormik.handleBlur}
                    ></textarea>
                    <label className="floating-label-text">
                      Reason of Rejection
                    </label>
                    {userFormik.touched.reason_of_rejection &&
                      userFormik.errors.reason_of_rejection && (
                        <div className="error">
                          {userFormik.errors.reason_of_rejection}
                        </div>
                      )}
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn">
                    Reject
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ListingApprovalSection;
